module.exports = __webpack_public_path__ + "static/img/oil4.c7bdd1cc.png";